import { PopoverButton } from "@headlessui/react";
import { ChevronDownIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { GLAWithIcon } from "../../../general/GLAWithIcon";
import type { GlAccount } from "../types";
import type { GlaSelectorTriggerSizeClasses } from "../triggerSizes";
import { cn } from "../../../../lib/utils.ts";
import { fieldVariants } from "../../../general/fieldStyles.ts";

interface GLASelectorPillProps {
    account: GlAccount;
    onClear: () => void;
    disabled?: boolean;
    sizeClasses: GlaSelectorTriggerSizeClasses;
    subledgerLabel?: string;
}

export function GLASelectorPill({
    account,
    onClear,
    disabled,
    sizeClasses,
    subledgerLabel,
}: GLASelectorPillProps) {
    const label = subledgerLabel ? `${account.label_nl} - ${subledgerLabel}` : account.label_nl;

    return (
        <div
            className={cn(
                fieldVariants(),
                "flex items-center",
                sizeClasses.pillWrapper,
                disabled ? "opacity-60" : "",
            )}
            title={label}
        >
            <PopoverButton
                disabled={disabled}
                className={`group flex min-w-0 flex-1 items-center gap-1.5 text-left outline-none ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`}
            >
                <GLAWithIcon
                    icon={account.icon}
                    label={label}
                    wrapperClassName={sizeClasses.pillIconGap}
                    iconSize={sizeClasses.pillIconSize}
                    labelClassName={sizeClasses.pillLabel}
                />
                {!disabled && (
                    <ChevronDownIcon
                        className={`ml-auto ${sizeClasses.chevron} shrink-0 text-gray-400 transition-transform group-data-[open]:rotate-180`}
                    />
                )}
            </PopoverButton>

            {!disabled && (
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onClear();
                    }}
                    className="shrink-0 rounded p-px text-gray-400 hover:bg-gray-100 hover:text-gray-600"
                >
                    <XMarkIcon className={sizeClasses.clearIcon} />
                </button>
            )}
        </div>
    );
}
